import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../lib/auth';

export function RegisterPage() {
  const navigate = useNavigate();
  const register = useAuth((s) => s.register);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [workspaceName, setWorkspaceName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(email, password, workspaceName);
      navigate('/app');
    } catch (err: any) {
      setError(err.message ?? 'Registration failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
      <h2 style={{ fontSize: 'var(--text-2xl)', fontWeight: 600, color: 'var(--color-text-primary)' }}>
        Create your workspace
      </h2>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)', margin: 0 }}>
        Free during beta. No credit card required.
      </p>

      <label style={labelStyle}>
        <span>Workspace name</span>
        <input
          type="text"
          value={workspaceName}
          onChange={(e) => setWorkspaceName(e.target.value)}
          placeholder="Acme Coaching"
          required
          autoFocus
          style={inputStyle}
        />
      </label>
      <label style={labelStyle}>
        <span>Email</span>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={inputStyle} />
      </label>
      <label style={labelStyle}>
        <span>Password</span>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={8}
          style={inputStyle}
        />
        <small style={{ color: 'var(--color-text-tertiary)', fontSize: 'var(--text-xs)' }}>
          At least 8 characters, one uppercase, one number
        </small>
      </label>

      {error && (
        <div style={{ color: 'var(--color-feedback-error)', fontSize: 'var(--text-sm)' }}>{error}</div>
      )}

      <button type="submit" disabled={loading} style={buttonStyle}>
        {loading ? 'Creating…' : 'Create workspace'}
      </button>

      <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)', textAlign: 'center' }}>
        Already have an account?{' '}
        <Link to="/auth/login" style={{ color: 'var(--color-brand-primary)', fontWeight: 500 }}>
          Sign in
        </Link>
      </div>
    </form>
  );
}

const labelStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--space-1)',
  fontSize: 'var(--text-sm)',
  color: 'var(--color-text-secondary)',
  fontWeight: 500,
};

const inputStyle: React.CSSProperties = {
  padding: 'var(--space-3)',
  border: '1px solid var(--color-border-primary)',
  borderRadius: 'var(--radius-md)',
  fontSize: 'var(--text-base)',
  color: 'var(--color-text-primary)',
  background: 'var(--color-surface-primary)',
  outline: 'none',
};

const buttonStyle: React.CSSProperties = {
  padding: 'var(--space-3)',
  background: 'var(--color-brand-primary)',
  color: 'white',
  border: 'none',
  borderRadius: 'var(--radius-md)',
  fontSize: 'var(--text-base)',
  fontWeight: 600,
  cursor: 'pointer',
};
